import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import BorderStack from 'components/@common/BorderStack';
import Link from 'components/@common/Link';
import SaudiRewardsLogo from 'components/@saudi-rewards/SaudiRewardsLogo';

const SaudiRewardsEarnedPointsBanner = () => {
  return (
    <>
      <BorderStack
        sx={(theme) => ({
          flexDirection: 'row',
          gap: theme.spacing(1.5),
          textAlign: 'left',
        })}
      >
        <SaudiRewardsLogo />
        <Stack>
          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', mb: 0.5, fontWeight: 'bold' }}
          >
            <FormattedMessage id="account.saudi.rewards.title" />
          </Typography>
          <Typography
            variant="small"
            sx={{
              color: 'text.secondary',
              mb: 1,
            }}
          >
            <FormattedMessage id="claim.points.confirmation.banner.description" />
          </Typography>
          <Link
            href={Routes.Account}
            variant="small"
            underline="always"
            color="text.secondary"
          >
            <FormattedMessage id="saudi.rewards.check.balance.button" />
          </Link>
        </Stack>
      </BorderStack>
    </>
  );
};

export default SaudiRewardsEarnedPointsBanner;
